import React, { Component } from "react";
import { InputField } from "../../../../common/custom-form/input-filter-component";
import { SelectField } from "../../../../common/custom-form/select-filter.component";

export class UserAccessInfo extends Component {
    constructor(props){
        super(props);
        this.state={
            inputValue: "",
            filterSelected: "", 
            showTable: false,
            showRate: false,
            detailsDropdown:[
                {
                    "title":"Plan Features",
                    "subTitle":"Feature Name",
                    "dataTable":[
                        {              
                            HeaderItem:[
                                {
                                    name:"Contract Name"
                                },
                                {
                                    name:"Vendor"
                                }, {
                                    name:"Status"
                                },{
                                    showTable:false
                                }
                            ],
                            dataItem:[{            
                                columnItem1:"3G Hutchison (GB) Contract",
                                columnItem2: "3G Hutchison (GB)",
                                columnItem3: "Expired"                       
                            }, {            
                                columnItem1:"3G Hutchison (GB) Contract",
                                columnItem2: "3G Hutchison (GB)",
                                columnItem3: "Expired"
                            },{            
                                columnItem1:"3G Hutchison (GB) Contract",
                                columnItem2: "3G Hutchison (GB)",
                                columnItem3: "Expired"
                            }        
                            ]
            
                        }
                    ]
                },{
                    "title":"Plan Rates",
                    "subTitle":"Rate Name",
                    "dataTable":[
                        {              
                            HeaderItem:[
                                {
                                    name:"Contract Name"
                                },
                                {
                                    name:"Vendor"
                                }, {
                                    name:"Status"
                                }, {
                                    showTable:false
                                }
                            ],
                            dataItem:[{            
                                columnItem1:"3G Hutchison (GB) Contract",
                                columnItem2: "3G Hutchison (GB)",
                                columnItem3: "Expired"                       
                            }, {            
                                columnItem1:"3G Hutchison (GB) Contract",
                                columnItem2: "3G Hutchison (GB)",
                                columnItem3: "Expired"
                            },{            
                                columnItem1:"3G Hutchison (GB) Contract",
                                columnItem2: "3G Hutchison (GB)",
                                columnItem3: "Expired"
                            }        
                            ]
            
                        }
                    ]
                }
            ],
            selectFilter:[
                {
                    "FilterId":5,
                    "FilterName":"Account Number",
                    "FilterType":"Textbox",
                    "Page":"CircuitInventoryReport",
                    "State":true,"Createdby":null,
                    "DateCreated":"0001-01-01T00:00:00",
                    "Modifiedby":null,
                    "DateModified":null,
                    "DropDownFilterOpts":null
                },
                {
                    "FilterId":4,
                    "FilterName":"Circuit ID",
                    "FilterType":"Textbox","Page":
                    "CircuitInventoryReport",
                    "State":true,"Createdby":null,
                    "DateCreated":"0001-01-01T00:00:00",
                    "Modifiedby":null,
                    "DateModified":null,
                    "DropDownFilterOpts":null
                },
                {
                    "FilterId":7,
                    "FilterName":"Circuit Status",
                    "FilterType":"Textbox",
                    "Page":"CircuitInventoryReport",
                    "State":true,"Createdby":null,
                    "DateCreated":"0001-01-01T00:00:00",
                    "Modifiedby":null,
                    "DateModified":null,
                    "DropDownFilterOpts":null
                }
               ],
               dataTable:[
                {              
                    HeaderItem:[
                        {
                            name:"Contract Name"
                        },
                        {
                            name:"Vendor"
                        }, {
                            name:"Status"
                        }
                    ],
                    dataItem:[{            
                        columnItem1:"3G Hutchison (GB) Contract",
                        columnItem2: "3G Hutchison (GB)",
                        columnItem3: "Expired"                       
                    }, {            
                        columnItem1:"3G Hutchison (GB) Contract",
                        columnItem2: "3G Hutchison (GB)",
                        columnItem3: "Expired"
                    },{            
                        columnItem1:"3G Hutchison (GB) Contract",
                        columnItem2: "3G Hutchison (GB)",
                        columnItem3: "Expired"
                    }        
                    ]
    
                }
            ],
        }
    }

  
    render() {
        return(
            <>
                <div className="manage-order-container">
                        <div className="manage-order-detail">
                            <SelectField label="USER NAME"  options={this.state.selectFilter} selected={this.state.filterSelected} onChange={(e)=>this.setState({filterSelected:e.target.value})}/> 
                            <SelectField label="EMAIL ADDRESS"  options={this.state.selectFilter} selected={this.state.filterSelected} onChange={(e)=>this.setState({filterSelected:e.target.value})}/>                                
                            <InputField label="FIRST NAME" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                            <InputField label="LAST NAME" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                            <InputField label="MIDDLE INITIAL" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                            <InputField label="CONTACT NO" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                            <InputField label="POSITION" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                            <InputField label="LINE MANAGER EMAIL" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                            <SelectField label="STATUS"  options={this.state.selectFilter} selected={this.state.filterSelected} onChange={(e)=>this.setState({filterSelected:e.target.value})}/> 
                            <SelectField label="RULE"  options={this.state.selectFilter} selected={this.state.filterSelected} onChange={(e)=>this.setState({filterSelected:e.target.value})}/> 
                        </div>
                    </div>                  
            </>
        )
    }
}